module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Culling_boundingInfo__;